import React, { useContext } from "react";
import { LoginReply } from "../../../core/api/contracts/login";

export const LoginContext = React.createContext<{ onLoginSuccess: (loginReply: LoginReply) => void }>(null);

export function usePostLogin() {
  return useContext(LoginContext);
}
